import React from "react";
import { t } from "@/lib/i18n";
import { useApp } from "@/context/AppContext";

const StepIndicator = ({ current, total = 5 }) => {
  const { language } = useApp();
  const steps = Array.from({ length: total }, (_, i) => i + 1);
  return (
    <div className="w-full" data-testid="step-indicator">
      <div className="flex items-center gap-2 text-xs text-slate-500 mb-3">
        <span className="font-medium text-[#006C35]">
          {t(language, "step")} {current} {t(language, "of")} {total}
        </span>
      </div>
      <div className="flex gap-1.5">
        {steps.map((s) => (
          <div
            key={s}
            className={`h-1.5 flex-1 rounded-full transition-colors ${
              s <= current ? "bg-[#006C35]" : "bg-slate-200"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
